export default __webpack_public_path__ + "static/media/slide-1.845e1f66.svg";